<template>
  <dialog-base
    no-padding
    :key="renderKey"
    tile
    :loading="false"
    v-bind="{ ...$props, ...$attrs }"
    header=""
    hide-close-icon
    loading-message=""
    body-class="mobile-nav-dialog-body"
    @close="close"
    max-width="100%"
    :value="showDialog"
    width="980px">
    <template v-if="!externalActivator" v-slot:activator="slotProps">
      <primary-button v-on="slotProps.on" v-bind="slotProps.attrs">
        {{ t('appointment.dialogs.appointmentDetailsDialog.buttons.viewAppointment') }}
      </primary-button>
    </template>
    <template v-slot:body>
      <v-sheet color="mobileblue" class="fill-height d-flex flex-column mobile-nav-dialog__sheet">
        <!-- Top bar: close + logo -->
        <div
          class="px-2 py-2 d-flex align-center flex-nowrap flex-shrink-0 mobile-nav-dialog__header">
          <v-btn
            :aria-label="t('navigation.mobile.closeMenu')"
            class="flex-shrink-0"
            data-testid="mobile-nav-dialog-close"
            icon
            type="button"
            variant="text"
            @click="close">
            <v-icon color="white" size="28">mdi-close</v-icon>
          </v-btn>
          <v-spacer />
          <div class="flex-shrink-0 pl-2 d-flex align-center">
            <mobile-opendock-logo />
          </div>
        </div>

        <!-- User info -->
        <div class="pt-2 pb-3 d-flex flex-column align-center justify-center text-white px-4">
          <strong class="is-uppercase">{{ userName }}</strong>
          <span class="font-size-x-small">{{ userRole }}</span>
        </div>

        <!-- Language selector — styled to fit the dark blue theme -->
        <div class="px-4 pb-3 flex-shrink-0 nav-lang-select">
          <language-select :user-id="$me?.id" />
        </div>

        <v-divider class="opacity-20 mb-1" color="white" thickness="1" />

        <!-- Nav items + footer -->
        <navigation-drawer-mobile :org-required="true" @close="close" />
      </v-sheet>
    </template>
  </dialog-base>
</template>

<script>
import upperFirst from 'lodash/upperFirst';
import dialogMixin from '@satellite/components/mixins/dialogMixin';
import NavigationDrawerMobile from '@/components/elements/mobile/NavigationDrawerMobile.vue';
import LanguageSelect from '@satellite/components/elements/selects/LanguageSelect';
import { useI18n } from 'vue-i18n';

/**
 * Nav dialog for mobile
 * @displayName Nav Dialog Mobile
 */
export default {
  components: { NavigationDrawerMobile, LanguageSelect },
  mixins: [dialogMixin],
  setup() {
    const { t } = useI18n();
    return { t };
  },
  computed: {
    userName() {
      return `${this.$me?.firstName} ${this.$me?.lastName}`;
    },
    userRole() {
      return upperFirst(this.$me?.role?.replace('role_', ''));
    }
  }
};
</script>

<style lang="scss" scoped>
/* Language select styled to match the dark blue nav background */
.nav-lang-select {
  :deep(.v-input) {
    max-width: 100% !important;
  }

  :deep(.v-field) {
    background: rgba(255, 255, 255, 0.08) !important;
    border-radius: 8px;
  }

  :deep(.v-field__outline) {
    --v-field-border-opacity: 0.4;
    color: #ffffff;
  }

  :deep(.v-field__outline__start),
  :deep(.v-field__outline__end),
  :deep(.v-field__outline__notch) {
    border-color: rgba(255, 255, 255, 0.4) !important;
  }

  :deep(.v-label) {
    color: rgba(255, 255, 255, 0.7) !important;
    opacity: 1 !important;
  }

  :deep(.v-field__input) {
    color: #ffffff !important;
  }

  :deep(.v-select__selection-text) {
    color: #ffffff !important;
  }

  :deep(.v-field__append-inner .v-icon) {
    color: rgba(255, 255, 255, 0.7) !important;
  }
}
</style>
